// Filter values are kept in sessionStorage, one entry per module.
// sessionStorage is copied into tabs opened with window.open, which lets a link
// pre-fill the filters of the module it opens.

const FILTERS_STORAGE_PREFIX = 'kp-filters-'
const getFiltersStorageKey = moduleId => `${FILTERS_STORAGE_PREFIX}${moduleId}`

export const loadModuleFilters = moduleId => {
    if (!moduleId) return {}
    try {
        const savedFilters = sessionStorage.getItem(getFiltersStorageKey(moduleId))
        return savedFilters ? JSON.parse(savedFilters) : {}
    } catch (e) {
        return {}
    }
}

export const saveModuleFilters = (moduleId, filters) => {
    if (!moduleId) return
    try {
        sessionStorage.setItem(getFiltersStorageKey(moduleId), JSON.stringify(filters))
    } catch (e) {
        // storage unavailable (private mode, quota): filters just won't be remembered
    }
}

export const mergeModuleFilters = (moduleId, filters) =>
    saveModuleFilters(moduleId, { ...loadModuleFilters(moduleId), ...filters })

// "/tracking/m-S-elemDataAnalysis" -> "m-S-elemDataAnalysis"
export const getModuleIdFromPath = path => path && path.split('/').filter(Boolean).pop()